import axios from 'axios';
import APP_CONSTANTS from '../constants';

const apiClient = axios.create({
  baseURL: APP_CONSTANTS.BASE_URL
});

export default apiClient;
